/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Player_Answer_Incorrect_AlreadyInputs */

const en_player_answer_incorrect_already = /** @type {(inputs: Player_Answer_Incorrect_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Already answered (incorrect)`)
};

const ja_player_answer_incorrect_already = /** @type {(inputs: Player_Answer_Incorrect_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`既に回答済み（不正解）`)
};

const fr_player_answer_incorrect_already = /** @type {(inputs: Player_Answer_Incorrect_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Déjà répondu (incorrect)`)
};

const de_player_answer_incorrect_already = /** @type {(inputs: Player_Answer_Incorrect_AlreadyInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bereits beantwortet (falsch)`)
};

/**
* | output |
* | --- |
* | "Already answered (incorrect)" |
*
* @param {Player_Answer_Incorrect_AlreadyInputs} inputs
* @param {{ locale?: "en" | "ja" | "fr" | "de" }} options
* @returns {LocalizedString}
*/
export const player_answer_incorrect_already = /** @type {((inputs?: Player_Answer_Incorrect_AlreadyInputs, options?: { locale?: "en" | "ja" | "fr" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Player_Answer_Incorrect_AlreadyInputs, { locale?: "en" | "ja" | "fr" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_player_answer_incorrect_already(inputs)
	if (locale === "ja") return ja_player_answer_incorrect_already(inputs)
	if (locale === "fr") return fr_player_answer_incorrect_already(inputs)
	return de_player_answer_incorrect_already(inputs)
});